export const UI_MODES = {
    light: 'light',
    dark: 'dark'
} as const